import type { FeatureMiddleware } from '@cast/api-client';
import { generateServicesHealth } from '@cast/fixtures';

import { getIsClusterDemoMode } from '@cast/infrastructure-demo';

export const services: FeatureMiddleware<'services'> = {
  listHealth: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      return resolve(generateServicesHealth());
    }
    return next();
  },
};
